<template>
	<form class="d-flex wrap">
		<div class="flex-45 mx-1 mb-1">
			<el-input
				placeholder="Alias"
				class="qtc-input"
				v-model="newAddress.name"
			></el-input>
			<span class="error-message" v-if="$v.newAddress.name.$invalid">El alias es requerido</span>
		</div>
		<div class="flex-45 mx-1 mb-1">
			<select-component
				:placeholder="countryLabels.department"
				item-text="name"
				item-value="id"
				:options="departments"
				v-model="newAddress.provinceId"
				@input="onDepartamenChange"
			/>
			<span class="error-message" v-if="$v.newAddress.provinceId.$invalid">El departamento es requerido</span>
		</div>
		<div class="flex-45 mx-1 mb-1">
			<select-component
				:placeholder="countryLabels.province"
				item-text="name"
				item-value="id"
				:disabled="!newAddress.provinceId"
				:options="provinces"
				@input="onProvinceChange"
				v-model="newAddress.cityId"
			/>
			<span class="error-message" v-if="$v.newAddress.cityId.$invalid">La Provincia es requerido</span>
		</div>
		<div class="flex-45 mx-1 mb-1">
			<select-component
				:placeholder="countryLabels.district"
				item-text="name"
				item-value="id"
				:disabled="!newAddress.cityId"
				:options="districts"
				v-model="newAddress.parishId"
			/>
			<span class="error-message" v-if="$v.newAddress.parishId.$invalid">El distrito es requerido</span>
		</div>
		<div class="flex-50 mx-1 mb-1">
			<input-component
				placeholder="Dirección"
				v-model="newAddress.addressLine1"
			>
				<span slot="err" class="error-message" v-if="$v.newAddress.addressLine1.$invalid">La dirección es requerida</span>
			</input-component>
		</div>
		<div class="flex-10 mx-1 mb-1">
			<el-input
				class="qtc-input"
				v-model="newAddress.number"
				placeholder="Nro"
			></el-input>
			<span class="error-message" v-if="$v.newAddress.number.$invalid">El número es requerido</span>
		</div>
		<div class="flex-95 mx-1 mb-1">
			<el-input
				class="qtc-input"
				v-model="newAddress.reference"
				placeholder="Referencia"
			></el-input>
			<span class="error-message" v-if="$v.newAddress.reference.$invalid">La referencia es requerida</span>
		</div>
	</form>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import inputComponent from '@/components/inputComponent';
import selectComponent from '@/components/selectComponent';
import { mapGetters } from 'vuex';

function created() {
	this.loadDepartments();
}

async function loadDepartments() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.departments } = await this.$httpJapi.get('province', { headers }));
}

async function onProvinceChange(provinceId) {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const requests = [
		this.$httpJapi.get(`parish/${provinceId}`, { headers }),
	];
	([{ data: this.districts }] = await Promise.all(requests));
}

function buildBody(provinceId) {
	const details = this.productsSelected.map((p) => {
		const newP = {};
		newP.weight = p.weigth || 0;
		newP.quantity = p.quantity;
		return newP;
	});
	return {
		details,
		provinceId,
	};
}

async function onDepartamenChange(departmentId) {
	const body = this.buildBody(departmentId);
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const requests = [
		this.$httpQtc.post('/weight/price', body, { headers }),
		this.$httpJapi.get(`cities/${departmentId}`, { headers }),
	];
	try {
		const [
			{ data: shippingCost },
			{ data: provinces },
		] = await Promise.all(requests);
		this.$store.commit('SET_SHIPPING_COST', shippingCost || 0);
		this.provinces = provinces;
	} catch (error) {
		if (error.response.data.message === 'PRICE_NOT_CONFIGURATION') {
			this.$store.commit('SET_SHIPPING_COST', null);
			this.$message({
				message: 'No es posible hacer envios a ese destino.',
				type: 'error',
			});
		}
	}
}

function validateForm(newVal) {
	if (!newVal.$invalid) {
		this.$store.commit('SET_NEW_ADDRESS_DATA', { ...this.newAddress });
		this.$store.commit('SET_VALID_NEW_ADDRESS', !this.$v.$invalid);
	}
}

function validations() {
	return {
		newAddress: {
			addressLine1: { required },
			name: { required },
			provinceId: { required },
			parishId: { required },
			number: { required },
			cityId: { required },
			reference: { required },
		},
	};
}

function data() {
	return {
		departments: [],
		districts: [],
		newAddress: {
			addressLine1: '',
			name: '',
			provinceId: '',
			parishId: '',
			number: '',
			cityId: '',
			reference: '',
		},
		provinces: [],
	};
}

export default {
	name: 'address-form',
	components: {
		inputComponent,
		selectComponent,
	},
	computed: {
		...mapGetters([
			'productsSelected',
			'token',
		]),
	},
	created,
	data,
	methods: {
		buildBody,
		loadDepartments,
		onDepartamenChange,
		onProvinceChange,
		validateForm,
	},
	validations,
	watch: {
		$v: {
			deep: true,
			handler: validateForm,
		},
	},
};
</script>




// WEBPACK FOOTER //
// addressForm.vue?0705d997